import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ColorsFilter from 'components/essentials/ColorsFilter';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
const ProductListingColorFilter = () => {
  const $ = _c(12);
  const {
    filters: t0,
    toggleFilterOption
  } = useProductListingPageContext();
  let T0;
  let activeColorOptions;
  let t1;
  let t2;
  if ($[0] !== t0) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const filters = t0 === undefined ? [] : t0;
      const colorFilter = filters.find(_temp);
      if (!colorFilter) {
        t2 = null;
        break bb0;
      }
      activeColorOptions = colorFilter.options?.filter(_temp2)?.map(_temp3).reduce(_temp4, {}) ?? {};
      T0 = ColorsFilter;
      t1 = colorFilter?.options?.map(_temp5);
    }
    $[0] = t0;
    $[1] = T0;
    $[2] = activeColorOptions;
    $[3] = t1;
    $[4] = t2;
  } else {
    T0 = $[1];
    activeColorOptions = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  let t3;
  if ($[5] !== toggleFilterOption) {
    t3 = optionId => {
      toggleFilterOption("color", optionId);
    };
    $[5] = toggleFilterOption;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== T0 || $[8] !== activeColorOptions || $[9] !== t1 || $[10] !== t3) {
    t4 = <T0 colors={t1} onSelectColor={t3} selectedColors={activeColorOptions} />;
    $[7] = T0;
    $[8] = activeColorOptions;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default ProductListingColorFilter;
function _temp(t0) {
  const {
    id
  } = t0;
  return id === "color";
}
function _temp2(t0) {
  const {
    isActive
  } = t0;
  return isActive;
}
function _temp3(t0) {
  const {
    id: id_0
  } = t0;
  return id_0;
}
function _temp4(acc, color) {
  return {
    ...acc,
    [color]: true
  };
}
function _temp5(option) {
  return option.id;
}